import { FC, ChangeEvent } from 'react';
import styled from 'styled-components';
import { CreateFormTheme } from '../../utils/themes';
import { useTheme } from '../../middleware/ThemeContext';

const StyledTextArea = styled('textarea')<{ $hasError?: boolean, disabled?: boolean }>(({ theme, $hasError, disabled }) => ({
  padding: '10px',
  color: disabled ? theme.CreateFormTheme.colors.placeHolder : theme.CreateFormTheme.colors.headerColor,
  backgroundColor: theme.CreateFormTheme.colors.inputBackground,
  opacity: disabled ? 0.7 : 1,
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '14px',
  border: `1px solid ${$hasError
    ? theme.CreateFormTheme.colors.error
    : theme.CreateFormTheme.colors.inputBorders
    }`,
  borderRadius: CreateFormTheme.borderRadius,
  fontFamily: "'Raleway', sans-serif",
  minHeight: '70px',
  width: '100%',
  '&:focus': {
    outline: `2px solid ${theme.CreateFormTheme.colors.border}`,
  },
  '::placeholder': {
    color: theme.CreateFormTheme.colors.placeHolder,
    opacity: 1,
  },
}));

interface CustomTextArea {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  type?: string;
  required?: boolean;
  error?: string;
  minLength?: number;
  maxLength?: number;
  disabled?: boolean;
}

const CustomTextArea: FC<CustomTextArea> = ({
  value,
  onChange,
  placeholder,
  type = 'TextArea',
  error,
  minLength,
  maxLength,
  disabled
}) => {
  const { theme } = useTheme();
  return (
    <StyledTextArea
      theme={theme}
      value={value}
      onChange={(e: ChangeEvent<HTMLTextAreaElement>) => onChange(e.target.value)}
      placeholder={placeholder}
      maxLength={maxLength}
      minLength={minLength}
      $hasError={!!error}
      disabled={disabled}
    />
  );
};

export default CustomTextArea;